import React from 'react';
import userRequired from './user-required';

const SigninSignupPage = (props) => {
  return (
    <main>
      <h4>Ciao {props.user.name}, benvenuto in {props.app.config.name}.</h4>
    </main>
  );
};

export default userRequired(SigninSignupPage);



// WEBPACK FOOTER //
// ./src/containers/user/signin-signup-page.js